import { Action, BannerTone } from '@shopify/polaris';

export interface BannerStore {
    key: BannerKey;
    position: BannerPosition;
    index: number;
    type: BannerType;
    titleKey?: string;
    descriptionKey?: string;
    descriptionInterpolation?: object;
    imgSrc?: string;
    imgSrcMobile?: string;
    tone?: BannerTone;
    action?: Action;
    secondaryAction?: Action;
    imgAlt?: string;
    mediaCardSize?: 'small' | 'medium';
}

export enum BannerKey {
    ONLY_FOR_SHOPIFY_PLUS,
    INTEGRATION_MODE_INTERACTIVE_MAP,
    LEGACY_PLAN_ACTIVE,
    PLAN_UPSELL_BANNER,
    UPSELL_CARD,
    PROVIDER_LIMIT_EXCEEDED,
    PLAN_CHANGE,
    ACTIVATED_PROVIDERS_LIMIT_REACHED,
    THIRD_PARTY_FULFILLMENT_LOCK,
}

export enum BannerPosition {
    INTEGRATION_MODE,
    INTEGRATION_MODE_INTERACTIVE_MAP,
    BILLING_PAGE,
    DASHBOARD_PAGE,
    BILLING_THANK_YOU_PAGE,
    SHIPPING_PROVIDER_PAGE,
}

export enum BannerType {
    BANNER,
    CALLOUT,
    MEDIA_CARD,
    CUSTOM,
    IMAGE,
}
